import React from 'react'


import NavbarHeader from '../Navbarheader/NavbarHeader';
import Footer from '../Footer/Footer';
import MainProject from './MainProject';

function ProjectPage() {
  return (
    <div fluid  className="scroll-container">
      <NavbarHeader />
      <div style={{backgroundColor:"#1C1B1B", paddingTop:"5rem"}}>
     
      <MainProject />
      </div>
      
      <Footer />
    </div>
  )
}

export default ProjectPage
